import { SoundPlayer } from '../game/audio/sounds';

let instance: SoundPlayer | null = null;

/**
 * Lazy-init singleton SoundPlayer for the learn UI.
 * Avoids creating a new AudioContext on every button click.
 */
export function getUiSoundPlayer(): SoundPlayer {
  if (!instance) instance = new SoundPlayer();
  return instance;
}

/** Set SFX volume on the learn-side sound player (0..1). */
export function setUiSoundVolume(v: number): void {
  getUiSoundPlayer().setVolume(v);
}

// Listen for volume changes dispatched by the settings UI.
window.addEventListener('ef:audio-volume', (e) => {
  const detail = (e as CustomEvent<{ bgm: number; sfx: number }>).detail;
  getUiSoundPlayer().setVolume(detail.sfx);
});
